import {useState, useEffect, forwardRef} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {initialVacancy} from './core/_models'
import {useParams, useLocation, useNavigate, Link} from 'react-router-dom'
import clsx from 'clsx'
import InputMask from 'react-input-mask'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import {MultiSelect} from 'react-multi-select-component'
import {customStyles} from '../../../../../utilities/customStyles'
import axios from 'axios'
import Select from 'react-select'
import {toast} from 'react-toastify'
import {VacancyistLoading} from './components/loading/VacancyistLoading'
import {createVacancy, getVacancyById, updateVacancy} from './core/_requests'
import {isNotEmpty} from '../../../../../_metronic/helpers'
import {useIntl} from 'react-intl'
import {useSelector} from 'react-redux'

const CreateVacancyOrUpdatePage = () => {
  const intl = useIntl()
  const [checkPositionField, setCheckPositionField] = useState(null)

  const vacancySchema = Yup.object().shape({
    grade: Yup.string().required(`${intl.formatMessage({id: 'REQUIRED'})}`),
    start_date: Yup.string().required(`${intl.formatMessage({id: 'REQUIRED'})}`),
    filling_statuses: Yup.string().nullable(),
    number_of_vacancies: Yup.string()
      .min(1, `${intl.formatMessage({id: 'AUTH.VALIDATION.MIN_LENGTH_FIELD'})} 1`)
      .required(`${intl.formatMessage({id: 'REQUIRED'})}`),
    company_id: Yup.string().required(`${intl.formatMessage({id: 'REQUIRED'})}`),
    enterprise_id: Yup.string().nullable(),
    director_id: Yup.string().nullable(),
    department_id: Yup.string().nullable(),
    sector_id: Yup.string().nullable(),
    area_id: Yup.string().nullable(),
    position_id: Yup.string().nullable(),
    position_name: Yup.string().nullable(),
    budget_status_id: Yup.string().nullable(),
    work_status_id: Yup.string().nullable(),
    cause_of_demand: Yup.string().nullable(),
    qualification_dictionary_id: Yup.string().required(`${intl.formatMessage({id: 'REQUIRED'})}`),
    working_condition_id: Yup.string().required(`${intl.formatMessage({id: 'REQUIRED'})}`),
    working_chart_id: Yup.string().required(`${intl.formatMessage({id: 'REQUIRED'})}`),
    marital_status_id: Yup.string().nullable(),
    sex_id: Yup.string().nullable(),
    minimum_age: Yup.string().required(`${intl.formatMessage({id: 'REQUIRED'})}`),
    maximum_age: Yup.string().required(`${intl.formatMessage({id: 'REQUIRED'})}`),
    currency_id: Yup.string().nullable(),
    salary_min: Yup.string().required(`${intl.formatMessage({id: 'REQUIRED'})}`),
    salary_max: Yup.string().required(`${intl.formatMessage({id: 'REQUIRED'})}`),
    driver_license_category_id: Yup.string().nullable(),
    job_sector_id: Yup.string().nullable(),
    work_experience_id: Yup.string().required(`${intl.formatMessage({id: 'REQUIRED'})}`),
    travel_status_id: Yup.string().nullable(),
    job_description: Yup.string().nullable(),
    language_id: Yup.string().nullable(),
    title: Yup.string().nullable(),
    description: Yup.string().nullable(),
    questions: Yup.array().nullable(),
    positions: Yup.array().nullable(),
    employees: Yup.array().nullable(),
  })

  const MaskedInput = forwardRef(({value, onChange, onClick}, ref) => (
    <div className='ui input' onClick={onClick}>
      <InputMask
        ref={ref}
        mask='99/99/9999'
        placeholder='dd/mm/yyyy'
        value={value ? value : 'dd/mm/yyyy'}
        onChange={onChange}
      />
    </div>
  ))

  const baseUrl = process.env.REACT_APP_BASE_URL

  const companies = useSelector((state) => state.persistedReducer.companies.companies)
  const languages = useSelector((state) => state.persistedReducer.selectedLanguage.languages)
  const navigate = useNavigate()

  const {id} = useParams()
  const {pathname} = useLocation()

  const [empStatuses, setEmpStatuses] = useState([])
  const [enterprises, setEnterPrises] = useState([])
  const [directorates, setDirectorates] = useState([])
  const [departments, setDepartments] = useState([])
  const [sectors, setSectors] = useState([])
  const [areas, setAreas] = useState([])
  const [qualifications, setQualifications] = useState([])
  const [positions, setPositions] = useState([])
  const [workConditions, setWorkConditions] = useState([])
  const [workSchedules, setWorkSchedules] = useState([])
  const [maritalStatues, setMaritalStatues] = useState([])
  const [sexes, setSexes] = useState([])
  const [drivingLicenses, setDrivingLicenses] = useState([])
  const [salaryCurrencies, setSalaryCurrencies] = useState([])

  const [workAreas, setWorkAreas] = useState([])
  const [workExpirences, setWorkExpirences] = useState([])

  const [travelStatuses, setTravelStatuses] = useState([])
  const [quess, setQuess] = useState([])
  const [selectQuess, setSelectQuess] = useState([])
  const [abiliTies, setAbilities] = useState([])
  const [selectAbilities, setSelectAbilities] = useState([])
  const [users, setUsers] = useState([])
  const [selectUsers, setSelectUsers] = useState([])

  const [checks, setChecks] = useState({
    checkOne: true,
    checkTwo: true,
    checkThree: true,
    checkFour: true,
    checkFive: true,
    checkSix: true,
  })
  const [budgets, setBudgets] = useState([])

  const [vacancyStatuses, setVacancyStatuses] = useState([])

  const [vacancyForEditAndCreate] = useState({
    grade: initialVacancy.grade,
    start_date: initialVacancy.start_date,
    filling_statuses: initialVacancy.filling_statuses,
    number_of_vacancies: initialVacancy.number_of_vacancies,
    company_id: initialVacancy.company_id,
    enterprise_id: initialVacancy.enterprise_id,
    director_id: initialVacancy.director_id,
    department_id: initialVacancy.department_id,
    sector_id: initialVacancy.sector_id,
    area_id: initialVacancy.area_id,
    position_id: initialVacancy.position_id,
    position_name: initialVacancy.position_name,
    budget_status_id: initialVacancy.budget_status_id,
    work_status_id: initialVacancy.status_id,
    cause_of_demand: initialVacancy.cause_of_demand,
    qualification_dictionary_id: initialVacancy.qualification_dictionary_id,
    working_condition_id: initialVacancy.working_condition_id,
    working_chart_id: initialVacancy.working_chart_id,
    marital_status_id: initialVacancy.marital_status_id,
    sex_id: initialVacancy.sex_id,
    minimum_age: initialVacancy.minimum_age,
    maximum_age: initialVacancy.maximum_age,
    currency_id: initialVacancy.currency_id,
    salary_min: initialVacancy.salary_min,
    salary_max: initialVacancy.salary_max,
    driver_license_category_id: initialVacancy.driver_license_category_id,
    job_sector_id: initialVacancy.job_sector_id,
    work_experience_id: initialVacancy.work_experience_id,
    travel_status_id: initialVacancy.travel_status_id,
    job_description: initialVacancy.job_description,
    language_id: initialVacancy.language_id,
    title: initialVacancy.title,
    description: initialVacancy.description,
    questions: initialVacancy.questions,
    positions: initialVacancy.positions,
    employees: initialVacancy.employees,
  })

  const formik = useFormik({
    initialValues: vacancyForEditAndCreate,
    validationSchema: vacancySchema,
    onSubmit: async (values, {setSubmitting}) => {
      setSubmitting(true)

      try {
        if (isNotEmpty(values.id)) {
          const result = await updateVacancy({
            ...values,
            filling_statuses: [values.filling_statuses],
            questions: values.questions.length > 0 ? values.questions?.map((v) => v?.value) : null,
            positions: values.positions.length > 0 ? values.positions?.map((p) => p?.value) : null,
            employees:
              values.employees.length > 0 ? values.employees?.map((emp) => emp?.value) : null,
            start_date: moment(values.start_date).format('YYYY-MM-DD'),
          })

          if (typeof result === 'string') {
            throw new Error(result)
          } else {
            toast.success(`${intl.formatMessage({id: 'SUCCESS.MESSAGE.UPDATE'})}`)
            navigate(-1)
          }
        } else {
          const result = await createVacancy({
            ...values,
            filling_statuses: [values.filling_statuses],
            questions: values.questions.length > 0 ? values.questions : null,
            positions: values.positions.length > 0 ? values.positions : null,
            employees: values.employees.length > 0 ? values.employees : null,
            start_date: moment(values.start_date).format('YYYY-MM-DD'),
          })
          if (typeof result === 'string') {
            throw new Error(result)
          } else {
            toast.success(`${intl.formatMessage({id: 'SUCCESS.MESSAGE.ADD'})}`)
            navigate(-1)
          }
        }
      } catch (error) {
        toast.error(error?.message, {
          autoClose: 10000,
        })
      } finally {
        setSubmitting(false)
      }
    },
  })

  const getVacancy = async () => {
    const result = await getVacancyById(id)

    formik.setFieldValue('id', result?.id)
    formik.setFieldValue('filling_statuses', result.filling_statuses[0]?.id)
    formik.setFieldValue('grade', result?.grade)
    formik.setFieldValue('start_date', result?.start_date)
    formik.setFieldValue('enterprise_id', result?.enterprise_id)

    formik.setFieldValue('director_id', result?.director_id)
    formik.setFieldValue('department_id', result?.department_id)
    formik.setFieldValue('sector_id', result?.sector_id)
    formik.setFieldValue('area_id', result?.area_id)
    formik.setFieldValue('position_id', result?.position_id)
    formik.setFieldValue('number_of_vacancies', result?.number_of_vacancies)
    formik.setFieldValue('position_name', result?.position_name)
    formik.setFieldValue('cause_of_demand', result?.cause_of_demand)
    formik.setFieldValue('company_id', result?.company_id)
    formik.setFieldValue('work_status_id', result?.work_status_id)
    formik.setFieldValue('budget_status_id', result?.budget_status_id)
    formik.setFieldValue('qualification_dictionary_id', result?.qualification_dictionary_id)
    formik.setFieldValue('working_condition_id', result?.working_condition_id)
    formik.setFieldValue('working_chart_id', result?.working_chart_id)
    formik.setFieldValue('marital_status_id', result?.marital_status_id)
    formik.setFieldValue('sex_id', result?.sex_id)
    formik.setFieldValue('driver_license_category_id', result?.driver_license_category_id)
    formik.setFieldValue('currency_id', result?.currency_id)
    formik.setFieldValue('job_sector_id', result?.job_sector_id)
    formik.setFieldValue('work_experience_id', result?.work_experience_id)
    formik.setFieldValue('travel_status_id', result?.travel_status_id)
    formik.setFieldValue('language_id', result?.language_id)
    formik.setFieldValue('job_description', result?.job_description)
    formik.setFieldValue('title', result?.title)
    formik.setFieldValue('description', result?.description)
    formik.setFieldValue('minimum_age', result?.minimum_age)
    formik.setFieldValue('maximum_age', result?.maximum_age)
    formik.setFieldValue('salary_min', result?.salary_min)
    formik.setFieldValue('salary_max', result?.salary_max)

    setChecks((prevState) => {
      return {
        ...prevState,
        checkOne: result.enterprise_id ? false : true,
        checkTwo: result.director_id ? false : true,
        checkThree: result.department_id ? false : true,
        checkFour: result.sector_id ? false : true,
        checkFive: result.area_id ? false : true,
        checkSix: result.position_id ? false : true,
      }
    })
    formik.setFieldValue(
      'questions',
      result.questions?.map((quess) => {
        return {
          value: quess?.id,
          label: quess?.name,
        }
      })
    )

    setSelectQuess(
      result.questions?.map((quess) => {
        return {
          value: quess?.id,
          label: quess?.name,
        }
      })
    )
    formik.setFieldValue(
      'positions',
      result.positions?.map((quess) => {
        return {
          value: quess?.id,
          label: quess?.firstname + quess.lastname,
        }
      })
    )
    setSelectAbilities(
      result.positions?.map((quess) => {
        return {
          value: quess?.id,
          label: quess?.firstname + quess.lastname,
        }
      })
    )
    formik.setFieldValue(
      'employees',
      result.employees?.map((emp) => {
        return {
          value: emp?.id,
          label: emp?.firstname + emp.lastname,
        }
      })
    )

    setSelectUsers(
      result.employees?.map((emp) => {
        return {
          value: emp?.id,
          label: emp?.firstname + emp?.lastname,
        }
      })
    )
    if (result.company_id) {
      getEnprises(result?.company_id)
    }

    if (result?.enterprise_id) {
      getDirectores(result?.enterprise_id)
    }
    if (result?.director_id) {
      getDepartments(result?.director_id)
    }
    if (result?.department_id) {
      getSectors(result?.department_id)
    }
    if (result?.sector_id) {
      getAreas(result?.sector_id)
    }

    if (result?.area_id) {
      getPositions(result?.area_id)
    }
  }

  const getAllFetchData = async () => {
    try {
      const urls = [
        `${process.env.REACT_APP_BASE_URL}/api/work-statuses`,
        `${process.env.REACT_APP_BASE_URL}/api/qualification-dictionaries`,
        `${process.env.REACT_APP_BASE_URL}/api/marital-statuses`,
        `${process.env.REACT_APP_BASE_URL}/api/sexes`,
        `${process.env.REACT_APP_BASE_URL}/api/driver-license-categories`,
        `${process.env.REACT_APP_BASE_URL}/api/employees`,
        `${process.env.REACT_APP_BASE_URL}/api/vacancy-statuses`,
        `${process.env.REACT_APP_BASE_URL}/api/budget-statuses`,
        `${process.env.REACT_APP_BASE_URL}/api/working-conditions`,
        `${process.env.REACT_APP_BASE_URL}/api/working-charts`,
        `${process.env.REACT_APP_BASE_URL}/api/currencies`,
        `${process.env.REACT_APP_BASE_URL}/api/job-sectors`,
        `${process.env.REACT_APP_BASE_URL}/api/work-experiences`,
        `${process.env.REACT_APP_BASE_URL}/api/travel-statuses`,
        `${process.env.REACT_APP_BASE_URL}/api/questions`,
      ]

      const requests = urls.map((url) => axios.get(url))

      const responses = await Promise.all(requests)

      responses.forEach((response, idx) => {
        if (response.status == 401) {
          localStorage.removeItem('token')
          navigate('/auth/login')
        } else if (response.status != 200) {
          throw new Error(response.data)
        } else {
          if (idx == 0) {
            setEmpStatuses(responses[idx].data)
          } else if (idx == 1) {
            setQualifications(responses[idx].data)
          } else if (idx == 2) {
            setMaritalStatues(responses[idx].data)
          } else if (idx == 3) {
            setSexes(responses[idx].data)
          } else if (idx == 4) {
            setDrivingLicenses(responses[idx].data)
          } else if (idx == 5) {
            setUsers(
              responses[idx].data?.map((us) => {
                return {
                  value: us?.id,
                  label: us?.firstname + us?.lastname,
                }
              })
            )
          } else if (idx == 6) {
            setVacancyStatuses(responses[idx].data)
          } else if (idx == 7) {
            setBudgets(responses[idx].data)
          } else if (idx == 8) {
            setWorkConditions(responses[idx].data)
          } else if (idx == 9) {
            setWorkSchedules(responses[idx].data.data)
          } else if (idx == 10) {
            setSalaryCurrencies(responses[idx].data)
          } else if (idx == 11) {
            setWorkAreas(responses[idx].data)
          } else if (idx == 12) {
            setWorkExpirences(responses[idx].data)
          } else if (idx == 13) {
            setTravelStatuses(responses[idx].data.data)
          } else if (idx == 14) {
            setQuess(
              responses[idx].data.data?.map((d) => {
                return {
                  value: d?.id,
                  label: d?.name,
                }
              })
            )
          }
        }
      })
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        autoClose: 10000,
      })
    }
  }

  const getEnprises = async (idd) => {
    try {
      const request = await axios.get(
        `${baseUrl}/api/categories?company_id=${idd}&structure_level_id=1`
      )

      if (request.status == 200) {
        setEnterPrises(
          request.data?.map((d) => {
            return {
              value: d?.id,
              label: d?.name,
            }
          })
        )
      } else {
        throw new Error(request.data)
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        localStorage.removeItem('token')
        navigate('/auth/login')
      } else {
        toast.error(error?.response?.data?.message, {
          autoClose: 10000,
        })
      }
    }
  }

  const getDirectores = async (idd) => {
    try {
      const request = await axios.get(
        `${baseUrl}/api/categories?parent_id=${idd}&structure_level_id=2`
      )

      if (request.status == 200) {
        setDirectorates(
          request.data?.map((d) => {
            return {
              value: d?.id,
              label: d?.name,
            }
          })
        )
      } else {
        throw new Error(request.data)
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        localStorage.removeItem('token')
        navigate('/auth/login')
      } else {
        toast.error(error?.response?.data?.message, {
          autoClose: 10000,
        })
      }
    }
  }

  const getDepartments = async (idd) => {
    try {
      const request = await axios.get(
        `${baseUrl}/api/categories?parent_id=${idd}&structure_level_id=3`
      )

      if (request.status == 200) {
        setDepartments(
          request.data?.map((d) => {
            return {
              value: d?.id,
              label: d?.name,
            }
          })
        )
      } else {
        throw new Error(request.data)
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        localStorage.removeItem('token')
        navigate('/auth/login')
      } else {
        toast.error(error?.response?.data?.message, {
          autoClose: 10000,
        })
      }
    }
  }
  const getSectors = async (idd) => {
    try {
      const request = await axios.get(
        `${baseUrl}/api/categories?parent_id=${idd}&structure_level_id=4`
      )

      if (request.status == 200) {
        setSectors(
          request.data?.map((d) => {
            return {
              value: d?.id,
              label: d?.label,
            }
          })
        )
      } else {
        throw new Error(request.data)
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        localStorage.removeItem('token')
        navigate('/auth/login')
      } else {
        toast.error(error?.response?.data?.message, {
          autoClose: 10000,
        })
      }
    }
  }

  const getAreas = async (idd) => {
    try {
      formik.setFieldValue('area_id', null)

      const request = await axios.get(
        `${baseUrl}/api/categories?parent_id=${idd}&structure_level_id=5`
      )

      if (request.status == 200) {
        setAreas(
          request.data?.map((d) => {
            return {
              value: d?.id,
              label: d?.name,
            }
          })
        )
      } else {
        throw new Error(request.data)
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        localStorage.removeItem('token')
        navigate('/auth/login')
      } else {
        toast.error(error?.response?.data?.message, {
          autoClose: 10000,
        })
      }
    }
  }

  const getPositions = async (idd) => {
    try {
      const request = await axios.get(`${baseUrl}/api/categories?parent_id=${idd}`)

      if (request.status == 200) {
        setPositions(
          request.data?.map((d) => {
            return {
              value: d?.id,
              label: d?.name,
            }
          })
        )
      } else {
        throw new Error(request.data)
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        localStorage.removeItem('token')
        navigate('/auth/login')
      } else {
        toast.error(error?.response?.data?.message, {
          autoClose: 10000,
        })
      }
    }
  }

  const selectDirectorateHandle = async (e) => {
    formik.setFieldValue('director_id', e)

    formik.setFieldValue('department_id', null)

    formik.setFieldValue('sector_id', null)

    formik.setFieldValue('area_id', null)

    formik.setFieldValue('position_id', null)

    setDepartments([])
    setSectors([])
    setAreas([])
    setPositions([])
    try {
      const request = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/categories?parent_id=${e}&structure_level_id=3`
      )

      if (request.status == 200) {
        setDepartments(
          request.data?.map((d) => {
            return {
              value: d?.id,
              label: d?.name,
            }
          })
        )
        setChecks((prevState) => (prevState = {...prevState, checkThree: false}))
      } else {
        throw new Error(request.data)
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        localStorage.removeItem('token')
        navigate('/auth/login')
      } else {
        toast.error(error?.response?.data?.message, {
          autoClose: 10000,
        })
      }
    }
  }

  const selectDepartmentHandle = async (e) => {
    formik.setFieldValue('department_id', e)
    formik.setFieldValue('sector_id', null)

    formik.setFieldValue('area_id', null)

    formik.setFieldValue('position_id', null)

    setSectors([])
    setAreas([])
    setPositions([])
    try {
      const request = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/categories?parent_id=${e}&structure_level_id=4`
      )

      if (request.status == 200) {
        setSectors(
          request.data?.map((d) => {
            return {
              value: d?.id,
              label: d?.label,
            }
          })
        )
        setChecks((prevState) => (prevState = {...prevState, checkFour: false}))
      } else {
        throw new Error(request.data)
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        localStorage.removeItem('token')
        navigate('/auth/login')
      } else {
        toast.error(error?.response?.data?.message, {
          autoClose: 10000,
        })
      }
    }
  }

  const selectSectorHandle = async (e) => {
    formik.setFieldValue('sector_id', e)
    formik.setFieldValue('area_id', null)

    formik.setFieldValue('position_id', null)
    setAreas([])
    setPositions([])

    try {
      const request = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/categories?parent_id=${e}&structure_level_id=5`
      )

      if (request.status == 200) {
        setAreas(
          request.data?.map((d) => {
            return {
              value: d?.id,
              label: d?.name,
            }
          })
        )
        setChecks((prevState) => (prevState = {...prevState, checkFive: false}))
      } else {
        throw new Error(request.data)
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        localStorage.removeItem('token')
        navigate('/auth/login')
      } else {
        toast.error(error?.response?.data?.message, {
          autoClose: 10000,
        })
      }
    }
  }

  const selectAreaHandle = async (e) => {
    formik.setFieldValue('area_id', e)
    formik.setFieldValue('position_id', null)
    setPositions([])
    try {
      const request = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/categories?parent_id=${e}`
      )

      if (request.status == 200) {
        setPositions(
          request.data?.map((d) => {
            return {
              value: d?.id,
              label: d?.name,
            }
          })
        )
        setChecks((prevState) => (prevState = {...prevState, checkSix: false}))
      } else {
        throw new Error(request.data)
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        localStorage.removeItem('token')
        navigate('/auth/login')
      } else {
        toast.error(error?.response?.data?.message, {
          autoClose: 10000,
        })
      }
    }
  }

  useEffect(() => {
    if (id) {
      getVacancy()
    }
    getAllFetchData()
  }, [id])

  const handleChangeCompany = async (event) => {
    formik.setFieldValue('company_id', event)

    formik.setFieldValue('enterprise_id', null)

    formik.setFieldValue('director_id', null)
    formik.setFieldValue('department_id', null)
    formik.setFieldValue('sector_id', null)
    formik.setFieldValue('area_id', null)
    formik.setFieldValue('position_id', null)
    setEnterPrises([])
    setDirectorates([])
    setDepartments([])
    setSectors([])
    setAreas([])
    setPositions([])

    try {
      const request = await axios.get(
        `${baseUrl}/api/categories?company_id=${event}&structure_level_id=1`
      )

      if (request.status == 200) {
        setEnterPrises(
          request.data?.map((d) => {
            return {
              value: d?.id,
              label: d?.name,
            }
          })
        )
        setChecks((prevState) => (prevState = {...prevState, checkOne: false}))
      } else {
        throw new Error(request.data)
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        localStorage.removeItem('token')
        navigate('/auth/login')
      } else {
        toast.error(error?.response?.data?.message, {
          autoClose: 10000,
        })
      }
    }
  }

  const handleChangeEnterprise = async (event) => {
    formik.setFieldValue('enterprise_id', event)
    formik.setFieldValue('director_id', null)

    formik.setFieldValue('department_id', null)

    formik.setFieldValue('sector_id', null)

    formik.setFieldValue('area_id', null)

    formik.setFieldValue('position_id', null)

    setDirectorates([])
    setDepartments([])
    setSectors([])
    setAreas([])
    setPositions([])

    try {
      const request = await axios.get(
        `${baseUrl}/api/categories?parent_id=${event}&structure_level_id=2`
      )

      if (request.status == 200) {
        setDirectorates(
          request.data?.map((d) => {
            return {
              value: d?.id,
              label: d?.name,
            }
          })
        )
        setChecks((prevState) => (prevState = {...prevState, checkTwo: false}))
      } else {
        throw new Error(request.data)
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        localStorage.removeItem('token')
        navigate('/auth/login')
      } else {
        toast.error(error?.response?.data?.message, {
          autoClose: 10000,
        })
      }
    }
  }

  const handleChangeNewPositionName = (event) => {
    formik.setFieldValue('position_name', event.target.value)

    if (event.target.value.length > 0) {
      setCheckPositionField(false)
    } else {
      setCheckPositionField(null)
    }
  }

  const handleSelectPosition = (event) => {
    formik.setFieldValue('position_id', event.target.value)

    if (event.target.value == '') {
      setCheckPositionField(null)
    } else {
      setCheckPositionField(true)
    }
  }

  return (
    <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header border-0 cursor-pointer'
        role='button'
        data-bs-toggle='collapse'
        data-bs-target='#kt_account_profile_details'
        aria-expanded='true'
        aria-controls='kt_account_profile_details'
      >
        <div className='card-title m-0'>
          <h3 className='fw-bold m-0'>
            {pathname.includes('view')
              ? intl.formatMessage({id: 'VIEW.VACANCY'})
              : id
              ? intl.formatMessage({id: 'UPDATE.VACANCY'})
              : intl.formatMessage({id: 'CREATE.VACANCY'})}
          </h3>
        </div>
      </div>
      <div id='kt_account_settings_profile_details' className='collapse show'>
        <form
          id='kt_account_profile_details_form'
          className='form fv-plugins-bootstrap5 fv-plugins-framework'
          onSubmit={formik.handleSubmit}
          noValidate
        >
          <div className='card-body border-top p-9'>
            <div className='vacancy_title_section mb-1'>
              <h3 className='mb-0'>{intl.formatMessage({id: 'REQUISITION_INFORMATION'})}</h3>
            </div>
            <div className='d-flex justify-space-between flex-wrap justify-content-between gap-2 align-items-stretch'>
              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label
                  className={`col-form-label fw-semibold fs-6 ${
                    pathname.includes('view') == false && 'required'
                  }`}
                >
                  {intl.formatMessage({id: 'START.DATE'})}
                </label>

                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <div className='w-100'>
                      <DatePicker
                        wrapperClassName='datePicker'
                        dateFormat='dd/MM/yyyy'
                        customInput={<MaskedInput />}
                        placeholder='-- -- --'
                        name='start_date'
                        selected={formik.values.start_date && new Date(formik.values.start_date)}
                        onChange={(opt) => formik.setFieldValue('start_date', opt)}
                        showMonthDropdown={true}
                        showYearDropdown={true}
                        shouldCloseOnSelect={true}
                        calendarStartDay={1}
                        scrollableYearDropdown={false}
                      />
                    </div>
                  ) : (
                    <p>{formik.values.start_date}</p>
                  )}
                  {formik.touched.start_date && formik.errors.start_date && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.start_date}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2 '>
                <label className={`col-form-label fw-semibold fs-6`}>
                  {intl.formatMessage({id: 'REQUEST.STATUS'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <select
                      {...formik.getFieldProps('filling_statuses')}
                      className={clsx(
                        'form-select form-select-solid mb-3 mb-lg-0',
                        {
                          'is-invalid':
                            formik.touched.filling_statuses && formik.errors.filling_statuses,
                        },
                        {
                          'is-valid':
                            formik.touched.filling_statuses && !formik.errors.filling_statuses,
                        }
                      )}
                      data-kt-select2='true'
                      data-placeholder='Select '
                      data-allow-clear='true'
                      disabled={formik.isSubmitting}
                    >
                      <option value=''>{intl.formatMessage({id: 'SELECT'})}</option>

                      {vacancyStatuses.length > 0 &&
                        vacancyStatuses.map((vacanStatus) => (
                          <option key={vacanStatus?.id} value={vacanStatus?.id}>
                            {vacanStatus?.name}
                          </option>
                        ))}
                    </select>
                  ) : (
                    <p>
                      {
                        vacancyStatuses.find((v) => v?.id == formik.values.filling_statuses[0])
                          ?.name
                      }
                    </p>
                  )}

                  {formik.touched.filling_statuses && formik.errors.filling_statuses && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.filling_statuses}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2 '>
                <label
                  className={`col-form-label fw-semibold fs-6 ${
                    pathname.includes('view') == false && 'required'
                  }`}
                >
                  {intl.formatMessage({id: 'NUMBER.OF.VACANCIES'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <input
                      type='number'
                      placeholder={intl.formatMessage({id: 'NUMBER.OF.VACANCIES'})}
                      {...formik.getFieldProps('number_of_vacancies')}
                      className={clsx(
                        'form-control form-control-solid mb-3 mb-lg-0',
                        {
                          'is-invalid':
                            formik.touched.number_of_vacancies && formik.errors.number_of_vacancies,
                        },
                        {
                          'is-valid':
                            formik.touched.number_of_vacancies &&
                            !formik.errors.number_of_vacancies,
                        }
                      )}
                    />
                  ) : (
                    <p>{formik.values.number_of_vacancies}</p>
                  )}

                  {formik.touched.number_of_vacancies && formik.errors.number_of_vacancies && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.number_of_vacancies}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className='vacancy_title_section mb-1'>
              <h3 className='mb-0'>{intl.formatMessage({id: 'POSITION_INFORMATION'})}</h3>
            </div>
            <div className='d-flex justify-space-between flex-wrap justify-content-between gap-2 align-items-stretch'>
              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label
                  className={`col-form-label fw-semibold fs-6 ${
                    pathname.includes('view') == false && 'required'
                  }`}
                >
                  {intl.formatMessage({id: 'COMPANY'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <Select
                      {...formik.getFieldProps('company_id')}
                      options={companies?.map((c) => {
                        return {
                          value: c?.id,
                          label: c?.name,
                        }
                      })}
                      styles={customStyles}
                      value={
                        formik.values.company_id
                          ? companies
                              ?.map((c) => {
                                return {
                                  value: c?.id,
                                  label: c?.name,
                                }
                              })
                              .find((c) => c?.value == formik.values.company_id)
                          : null
                      }
                      placeholder={intl.formatMessage({id: 'SELECT'})}
                      onChange={(opt) => {
                        handleChangeCompany(opt?.value)
                      }}
                    />
                  ) : (
                    <p>{companies?.find((c) => c?.id == formik.values.company_id)?.name}</p>
                  )}

                  {formik.touched.company_id && formik.errors.company_id && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.company_id}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label fw-semibold fs-6'>
                  {intl.formatMessage({id: 'ENTERPRISE'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <Select
                      {...formik.getFieldProps('enterprise_id')}
                      options={enterprises}
                      styles={customStyles}
                      value={
                        formik.values.enterprise_id
                          ? enterprises?.find((en) => en?.value == formik.values.enterprise_id)
                          : null
                      }
                      isDisabled={checks.checkOne}
                      placeholder={intl.formatMessage({id: 'SELECT'})}
                      onChange={(opt) => {
                        handleChangeEnterprise(opt?.value)
                      }}
                    />
                  ) : (
                    <p>
                      {enterprises.length > 0 &&
                        enterprises?.find((e) => e?.value == formik.values.enterprise_id)?.label}
                    </p>
                  )}

                  {formik.touched.enterprise_id && formik.errors.enterprise_id && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.enterprise_id}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label fw-semibold fs-6'>
                  {intl.formatMessage({id: 'DIRECTORATE'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <Select
                      {...formik.getFieldProps('director_id')}
                      options={directorates}
                      styles={customStyles}
                      value={
                        formik.values.director_id
                          ? directorates?.find((dir) => dir?.value == formik.values.director_id)
                          : null
                      }
                      isDisabled={checks.checkTwo}
                      placeholder={intl.formatMessage({id: 'SELECT'})}
                      onChange={(opt) => {
                        selectDirectorateHandle(opt?.value)
                      }}
                    />
                  ) : (
                    <p>
                      {directorates.length > 0 &&
                        directorates?.find((d) => d?.value == formik.values.director_id)?.label}
                    </p>
                  )}
                  {formik.touched.director_id && formik.errors.director_id && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.director_id}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label fw-semibold fs-6'>
                  {intl.formatMessage({id: 'DEPARTMENT'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <Select
                      {...formik.getFieldProps('department_id')}
                      options={departments}
                      styles={customStyles}
                      isDisabled={checks.checkThree}
                      value={
                        formik.values.department_id
                          ? departments?.find((dep) => dep?.value == formik.values.department_id)
                          : null
                      }
                      placeholder={intl.formatMessage({id: 'SELECT'})}
                      onChange={(opt) => {
                        selectDepartmentHandle(opt?.value)
                      }}
                    />
                  ) : (
                    <p>
                      {departments.length > 0 &&
                        departments?.find((d) => d?.value == formik.values.department_id)?.label}
                    </p>
                  )}
                  {formik.touched.department_id && formik.errors.department_id && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.department_id}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className='d-flex justify-space-between flex-wrap justify-content-between gap-2 align-items-stretch'>
              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label fw-semibold fs-6'>
                  {intl.formatMessage({id: 'BRANCHH'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <Select
                      {...formik.getFieldProps('sector_id')}
                      options={sectors}
                      styles={customStyles}
                      isDisabled={checks.checkFour}
                      value={
                        formik.values.sector_id
                          ? sectors?.find((sec) => sec?.value == formik.values.sector_id)
                          : null
                      }
                      placeholder={intl.formatMessage({id: 'SELECT'})}
                      onChange={(opt) => {
                        selectSectorHandle(opt?.value)
                      }}
                    />
                  ) : (
                    <p>
                      {sectors.length > 0 &&
                        sectors?.find((s) => s?.value == formik.values?.sector_id)?.label}
                    </p>
                  )}
                  {formik.touched.sector_id && formik.errors.sector_id && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.sector_id}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label fw-semibold fs-6'>
                  {intl.formatMessage({id: 'AREA.SECTION'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <Select
                      {...formik.getFieldProps('area_id')}
                      options={areas}
                      styles={customStyles}
                      isDisabled={checks.checkFive}
                      value={
                        formik.values.area_id
                          ? areas?.find((are) => are?.value == formik.values.area_id)
                          : null
                      }
                      placeholder={intl.formatMessage({id: 'SELECT'})}
                      onChange={(opt) => {
                        selectAreaHandle(opt?.value)
                      }}
                    />
                  ) : (
                    <p>
                      {areas.length > 0 &&
                        areas?.find((a) => a?.value == formik.values.area_id)?.label}
                    </p>
                  )}
                  {formik.touched.area_id && formik.errors.area_id && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.area_id}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label fw-semibold fs-6'>
                  {intl.formatMessage({id: 'POSIT'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <Select
                      {...formik.getFieldProps('position_id')}
                      options={positions}
                      styles={customStyles}
                      isDisabled={checks.checkSix}
                      value={
                        formik.values.position_id
                          ? positions?.find((pos) => pos?.value == formik.values.position_id)
                          : null
                      }
                      placeholder={intl.formatMessage({id: 'SELECT'})}
                    />
                  ) : (
                    <p>
                      {positions.length > 0 &&
                        positions?.find((p) => p?.value == formik.values?.position_id)?.label}
                    </p>
                  )}
                  {formik.touched.position_id && formik.errors.position_id && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.position_id}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label fw-semibold fs-6'>
                  {intl.formatMessage({id: 'NEW.POSITION.NAME'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <input
                      type='text'
                      placeholder={intl.formatMessage({id: 'NEW.POSITION.NAME'})}
                      {...formik.getFieldProps('position_name')}
                      onChange={(e) => handleChangeNewPositionName(e)}
                      className={clsx(
                        'form-control form-control-solid mb-3 mb-lg-0',
                        {
                          'is-invalid': formik.touched.position_name && formik.errors.position_name,
                        },
                        {
                          'is-valid': formik.touched.position_name && !formik.errors.position_name,
                        }
                      )}
                    />
                  ) : (
                    <p>{formik.values.position_name}</p>
                  )}
                  {/* end::Input */}
                  {formik.touched.position_name && formik.errors.position_name && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.position_name}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className='d-flex justify-space-between flex-wrap justify-content-between gap-2 align-items-stretch'>
              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label fw-semibold fs-6'>
                  {intl.formatMessage({id: 'REASON.FOR.DEMAND'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <input
                      type='text'
                      placeholder={intl.formatMessage({id: 'REASON.FOR.DEMAND'})}
                      {...formik.getFieldProps('cause_of_demand')}
                      className={clsx(
                        'form-control form-control-solid mb-3 mb-lg-0',
                        {
                          'is-invalid':
                            formik.touched.cause_of_demand && formik.errors.cause_of_demand,
                        },
                        {
                          'is-valid':
                            formik.touched.cause_of_demand && !formik.errors.cause_of_demand,
                        }
                      )}
                    />
                  ) : (
                    <p>{formik.values.cause_of_demand}</p>
                  )}
                  {/* end::Input */}
                  {formik.touched.cause_of_demand && formik.errors.cause_of_demand && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.cause_of_demand}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label fw-semibold fs-6'>
                  {intl.formatMessage({id: 'BUDGET.STATUS'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <select
                      {...formik.getFieldProps('budget_status_id')}
                      className={clsx(
                        'form-select form-select-solid mb-3 mb-lg-0',
                        {
                          'is-invalid':
                            formik.touched.budget_status_id && formik.errors.budget_status_id,
                        },
                        {
                          'is-valid':
                            formik.touched.budget_status_id && !formik.errors.budget_status_id,
                        }
                      )}
                      data-kt-select2='true'
                      data-placeholder='Select '
                      data-allow-clear='true'
                      disabled={formik.isSubmitting}
                    >
                      <option value=''>{intl.formatMessage({id: 'SELECT'})}</option>
                      {budgets.length > 0 &&
                        budgets.map((bud) => (
                          <option key={bud?.id} value={bud?.id}>
                            {bud?.option}
                          </option>
                        ))}
                    </select>
                  ) : (
                    <p>
                      {budgets.length > 0 &&
                        budgets.find((b) => b?.id == formik.values.budget_status_id)?.option}
                    </p>
                  )}
                  {/* end::Input */}
                  {formik.touched.budget_status_id && formik.errors.budget_status_id && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.budget_status_id}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label required fw-semibold fs-6'>
                  {intl.formatMessage({id: 'WORKING.CONDITION'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <select
                      {...formik.getFieldProps('working_condition_id')}
                      className={clsx(
                        'form-select form-select-solid mb-3 mb-lg-0',
                        {
                          'is-invalid':
                            formik.touched.working_condition_id &&
                            formik.errors.working_condition_id,
                        },
                        {
                          'is-valid':
                            formik.touched.working_condition_id &&
                            !formik.errors.working_condition_id,
                        }
                      )}
                      data-kt-select2='true'
                      data-placeholder='Select '
                      data-allow-clear='true'
                      disabled={formik.isSubmitting}
                    >
                      <option value=''>{intl.formatMessage({id: 'SELECT'})}</option>

                      {workConditions.length > 0 &&
                        workConditions.map((workCondition) => (
                          <option key={workCondition?.id} value={workCondition?.id}>
                            {workCondition?.title}
                          </option>
                        ))}
                    </select>
                  ) : (
                    <p>
                      {workConditions.length > 0 &&
                        workConditions?.find((w) => w?.id == formik.values.working_condition_id)
                          ?.title}
                    </p>
                  )}
                  {/* end::Input */}
                  {formik.touched.working_condition_id && formik.errors.working_condition_id && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.working_condition_id}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label required fw-semibold fs-6'>
                  {intl.formatMessage({id: 'JOB.CHART'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <select
                      {...formik.getFieldProps('working_chart_id')}
                      className={clsx(
                        'form-select form-select-solid mb-3 mb-lg-0',
                        {
                          'is-invalid':
                            formik.touched.working_chart_id && formik.errors.working_chart_id,
                        },
                        {
                          'is-valid':
                            formik.touched.working_chart_id && !formik.errors.working_chart_id,
                        }
                      )}
                      data-kt-select2='true'
                      data-placeholder='Select '
                      data-allow-clear='true'
                      disabled={formik.isSubmitting}
                    >
                      <option value=''>{intl.formatMessage({id: 'SELECT'})}</option>

                      {workSchedules.length > 0 &&
                        workSchedules.map((workSchedule) => (
                          <option key={workSchedule?.id} value={workSchedule?.id}>
                            {workSchedule?.name}
                          </option>
                        ))}
                    </select>
                  ) : (
                    <p>
                      {workSchedules.length > 0 &&
                        workSchedules?.find((wS) => wS?.id == formik.values.working_chart_id)?.name}
                    </p>
                  )}
                  {/* end::Input */}
                  {formik.touched.working_chart_id && formik.errors.working_chart_id && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.working_chart_id}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className='d-flex justify-space-between flex-wrap justify-content-between gap-2 align-items-stretch'>
              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label fw-semibold fs-6'>
                  {intl.formatMessage({id: 'SALARY.CURRENCY'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <select
                      {...formik.getFieldProps('currency_id')}
                      className={clsx(
                        'form-select form-select-solid mb-3 mb-lg-0',
                        {
                          'is-invalid': formik.touched.currency_id && formik.errors.currency_id,
                        },
                        {
                          'is-valid': formik.touched.currency_id && !formik.errors.currency_id,
                        }
                      )}
                      data-kt-select2='true'
                      data-placeholder='Select '
                      data-allow-clear='true'
                      disabled={formik.isSubmitting}
                    >
                      <option value=''>{intl.formatMessage({id: 'SELECT'})}</option>

                      {salaryCurrencies.length > 0 &&
                        salaryCurrencies.map((salaryCurrency) => (
                          <option key={salaryCurrency?.id} value={salaryCurrency?.id}>
                            {salaryCurrency?.title}
                          </option>
                        ))}
                    </select>
                  ) : (
                    <p>
                      {salaryCurrencies.length > 0 &&
                        salaryCurrencies?.find((s) => s?.id == formik.values.currency_id)?.title}
                    </p>
                  )}
                  {/* end::Input */}
                  {formik.touched.currency_id && formik.errors.currency_id && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.currency_id}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label fw-semibold fs-6'>
                  {intl.formatMessage({id: 'WORKING.AREA'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <select
                      {...formik.getFieldProps('job_sector_id')}
                      className={clsx(
                        'form-select form-select-solid mb-3 mb-lg-0',
                        {
                          'is-invalid': formik.touched.job_sector_id && formik.errors.job_sector_id,
                        },
                        {
                          'is-valid': formik.touched.job_sector_id && !formik.errors.job_sector_id,
                        }
                      )}
                      data-kt-select2='true'
                      data-placeholder='Select '
                      data-allow-clear='true'
                      disabled={formik.isSubmitting}
                    >
                      <option value=''>{intl.formatMessage({id: 'SELECT'})}</option>

                      {workAreas.length > 0 &&
                        workAreas.map((workArea) => (
                          <option key={workArea?.id} value={workArea?.id}>
                            {workArea?.value}
                          </option>
                        ))}
                    </select>
                  ) : (
                    <p>
                      {workAreas.length > 0 &&
                        workAreas?.find((wA) => wA?.id == formik.values.job_sector_id)?.value}
                    </p>
                  )}
                  {/* end::Input */}
                  {formik.touched.job_sector_id && formik.errors.job_sector_id && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.job_sector_id}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label fw-semibold fs-6'>
                  {intl.formatMessage({id: 'TRAVEL.STATUS'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <select
                      {...formik.getFieldProps('travel_status_id')}
                      className={clsx(
                        'form-select form-select-solid mb-3 mb-lg-0',
                        {
                          'is-invalid':
                            formik.touched.travel_status_id && formik.errors.travel_status_id,
                        },
                        {
                          'is-valid':
                            formik.touched.travel_status_id && !formik.errors.travel_status_id,
                        }
                      )}
                      data-kt-select2='true'
                      data-placeholder='Select '
                      data-allow-clear='true'
                      disabled={formik.isSubmitting}
                    >
                      <option value=''>{intl.formatMessage({id: 'SELECT'})}</option>

                      {travelStatuses.length > 0 &&
                        travelStatuses.map((travelStatus) => (
                          <option key={travelStatus?.id} value={travelStatus?.id}>
                            {travelStatus?.name}
                          </option>
                        ))}
                    </select>
                  ) : (
                    <p>
                      {travelStatuses.length > 0 &&
                        travelStatuses?.find((tS) => tS?.id == formik.values.travel_status_id)
                          ?.name}
                    </p>
                  )}
                  {formik.touched.travel_status_id && formik.errors.travel_status_id && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.travel_status_id}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label fw-semibold fs-6'>
                  {intl.formatMessage({id: 'JOB.DESCRIPTION'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <input
                      type='text'
                      placeholder={intl.formatMessage({id: 'JOB.DESCRIPTION'})}
                      {...formik.getFieldProps('job_description')}
                      className={clsx(
                        'form-control form-control-solid mb-3 mb-lg-0',
                        {
                          'is-invalid':
                            formik.touched.job_description && formik.errors.job_description,
                        },
                        {
                          'is-valid':
                            formik.touched.job_description && !formik.errors.job_description,
                        }
                      )}
                    />
                  ) : (
                    <p>{formik.values.job_description}</p>
                  )}
                  {/* end::Input */}
                  {formik.touched.job_description && formik.errors.job_description && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.job_description}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label fw-semibold fs-6'>
                  {intl.formatMessage({id: 'STATUS'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <select
                      {...formik.getFieldProps('work_status_id')}
                      className={clsx(
                        'form-select form-select-solid mb-3 mb-lg-0',
                        {
                          'is-invalid':
                            formik.touched.work_status_id && formik.errors.work_status_id,
                        },
                        {
                          'is-valid':
                            formik.touched.work_status_id && !formik.errors.work_status_id,
                        }
                      )}
                      data-kt-select2='true'
                      data-placeholder='Select '
                      data-allow-clear='true'
                      disabled={formik.isSubmitting}
                    >
                      <option value=''>{intl.formatMessage({id: 'SELECT'})}</option>
                      {empStatuses.length > 0 &&
                        empStatuses.map((em) => (
                          <option key={em?.id} value={em?.id}>
                            {em?.title}
                          </option>
                        ))}
                    </select>
                  ) : (
                    <p>
                      {empStatuses.length > 0 &&
                        empStatuses?.find((e) => e?.id == formik.values.work_status_id)?.title}
                    </p>
                  )}
                  {/* end::Input */}
                  {formik.touched.work_status_id && formik.errors.work_status_id && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.work_status_id}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className='vacancy_title_section mb-1'>
              <h3 className='mb-0'>{intl.formatMessage({id: 'EMPLOYEE_INFORMATION'})}</h3>
            </div>
            <div className='d-flex justify-space-between flex-wrap justify-content-between gap-2 align-items-stretch'>
              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label required fw-semibold fs-6'>
                  {intl.formatMessage({id: 'EDUC'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <select
                      {...formik.getFieldProps('qualification_dictionary_id')}
                      className={clsx(
                        'form-select form-select-solid mb-3 mb-lg-0',
                        {
                          'is-invalid':
                            formik.touched.qualification_dictionary_id &&
                            formik.errors.qualification_dictionary_id,
                        },
                        {
                          'is-valid':
                            formik.touched.qualification_dictionary_id &&
                            !formik.errors.qualification_dictionary_id,
                        }
                      )}
                      data-kt-select2='true'
                      data-placeholder='Select '
                      data-allow-clear='true'
                      disabled={formik.isSubmitting}
                    >
                      <option value=''>{intl.formatMessage({id: 'SELECT'})}</option>

                      {qualifications.length > 0 &&
                        qualifications.map((qua) => (
                          <option key={qua?.id} value={qua?.id}>
                            {qua?.label}
                          </option>
                        ))}
                    </select>
                  ) : (
                    <p>
                      {qualifications.length > 0 &&
                        qualifications?.find(
                          (q) => q?.id == formik.values.qualification_dictionary_id
                        )?.label}
                    </p>
                  )}
                  {/* end::Input */}
                  {formik.touched.qualification_dictionary_id &&
                    formik.errors.qualification_dictionary_id && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span role='alert'>{formik.errors.qualification_dictionary_id}</span>
                        </div>
                      </div>
                    )}
                </div>
              </div>

              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label fw-semibold fs-6'>
                  {intl.formatMessage({id: 'MARITAL.STATUS'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <select
                      {...formik.getFieldProps('marital_status_id')}
                      className={clsx(
                        'form-select form-select-solid mb-3 mb-lg-0',
                        {
                          'is-invalid':
                            formik.touched.marital_status_id && formik.errors.marital_status_id,
                        },
                        {
                          'is-valid':
                            formik.touched.marital_status_id && !formik.errors.marital_status_id,
                        }
                      )}
                      data-kt-select2='true'
                      data-placeholder='Select '
                      data-allow-clear='true'
                      disabled={formik.isSubmitting}
                    >
                      <option value=''>{intl.formatMessage({id: 'SELECT'})}</option>

                      {maritalStatues.length > 0 &&
                        maritalStatues.map((maritalStatus) => (
                          <option key={maritalStatus?.id} value={maritalStatus?.id}>
                            {maritalStatus?.label}
                          </option>
                        ))}
                    </select>
                  ) : (
                    <p>
                      {maritalStatues.length > 0 &&
                        maritalStatues?.find((mS) => mS?.id == formik.values.marital_status_id)
                          ?.label}
                    </p>
                  )}
                  {/* end::Input */}
                  {formik.touched.marital_status_id && formik.errors.marital_status_id && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.marital_status_id}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label fw-semibold fs-6'>
                  {intl.formatMessage({id: 'GENDER'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <select
                      {...formik.getFieldProps('sex_id')}
                      className={clsx(
                        'form-select form-select-solid mb-3 mb-lg-0',
                        {
                          'is-invalid': formik.touched.sex_id && formik.errors.sex_id,
                        },
                        {
                          'is-valid': formik.touched.sex_id && !formik.errors.sex_id,
                        }
                      )}
                      data-kt-select2='true'
                      data-placeholder='Select '
                      data-allow-clear='true'
                      disabled={formik.isSubmitting}
                    >
                      <option value=''>{intl.formatMessage({id: 'SELECT'})}</option>

                      {sexes.length > 0 &&
                        sexes.map((sex) => (
                          <option key={sex?.id} value={sex?.id}>
                            {sex?.label}
                          </option>
                        ))}
                    </select>
                  ) : (
                    <p>
                      {sexes.length > 0 && sexes?.find((s) => s?.id == formik.values.sex_id)?.label}
                    </p>
                  )}
                  {/* end::Input */}
                  {formik.touched.sex_id && formik.errors.sex_id && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.sex_id}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label required fw-semibold fs-6'>
                  {intl.formatMessage({id: 'MINIMUM.AGE'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <input
                      type='number'
                      placeholder={intl.formatMessage({id: 'MINIMUM.AGE'})}
                      {...formik.getFieldProps('minimum_age')}
                      className={clsx(
                        'form-control form-control-solid mb-3 mb-lg-0',
                        {
                          'is-invalid': formik.touched.minimum_age && formik.errors.minimum_age,
                        },
                        {
                          'is-valid': formik.touched.minimum_age && !formik.errors.minimum_age,
                        }
                      )}
                    />
                  ) : (
                    <p>{formik.values.minimum_age}</p>
                  )}
                  {/* end::Input */}
                  {formik.touched.minimum_age && formik.errors.minimum_age && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.minimum_age}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className='d-flex justify-space-between flex-wrap justify-content-between gap-2 align-items-stretch'>
              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label required fw-semibold fs-6'>
                  {intl.formatMessage({id: 'MAXIMUM.AGE'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <input
                      type='number'
                      placeholder={intl.formatMessage({id: 'MAXIMUM.AGE'})}
                      {...formik.getFieldProps('maximum_age')}
                      className={clsx(
                        'form-control form-control-solid mb-3 mb-lg-0',
                        {
                          'is-invalid': formik.touched.maximum_age && formik.errors.maximum_age,
                        },
                        {
                          'is-valid': formik.touched.maximum_age && !formik.errors.maximum_age,
                        }
                      )}
                    />
                  ) : (
                    <p>{formik.values.maximum_age}</p>
                  )}
                  {/* end::Input */}
                  {formik.touched.maximum_age && formik.errors.maximum_age && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.maximum_age}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label fw-semibold fs-6'>
                  {intl.formatMessage({id: 'DRIVING_LICENSE.INFO'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <select
                      {...formik.getFieldProps('driver_license_category_id')}
                      className={clsx(
                        'form-select form-select-solid mb-3 mb-lg-0',
                        {
                          'is-invalid':
                            formik.touched.driver_license_category_id &&
                            formik.errors.driver_license_category_id,
                        },
                        {
                          'is-valid':
                            formik.touched.driver_license_category_id &&
                            !formik.errors.driver_license_category_id,
                        }
                      )}
                      data-kt-select2='true'
                      data-placeholder='Select '
                      data-allow-clear='true'
                      disabled={formik.isSubmitting}
                    >
                      <option value=''>{intl.formatMessage({id: 'SELECT'})}</option>

                      {drivingLicenses.length > 0 &&
                        drivingLicenses.map((drivingLicense) => (
                          <option key={drivingLicense?.id} value={drivingLicense?.id}>
                            {drivingLicense?.description}
                          </option>
                        ))}
                    </select>
                  ) : (
                    <p>
                      {drivingLicenses.length > 0 &&
                        drivingLicenses?.find(
                          (d) => d?.id == formik.values.driver_license_category_id
                        )?.description}
                    </p>
                  )}
                  {/* end::Input */}
                  {formik.touched.driver_license_category_id &&
                    formik.errors.driver_license_category_id && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span role='alert'>{formik.errors.driver_license_category_id}</span>
                        </div>
                      </div>
                    )}
                </div>
              </div>

              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label required fw-semibold fs-6'>
                  {intl.formatMessage({id: 'WORK.EXPERIENCE'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <select
                      {...formik.getFieldProps('work_experience_id')}
                      className={clsx(
                        'form-select form-select-solid mb-3 mb-lg-0',
                        {
                          'is-invalid':
                            formik.touched.work_experience_id && formik.errors.work_experience_id,
                        },
                        {
                          'is-valid':
                            formik.touched.work_experience_id && !formik.errors.work_experience_id,
                        }
                      )}
                      data-kt-select2='true'
                      data-placeholder='Select '
                      data-allow-clear='true'
                      disabled={formik.isSubmitting}
                    >
                      <option value=''>{intl.formatMessage({id: 'SELECT'})}</option>

                      {workExpirences.length > 0 &&
                        workExpirences.map((workExpirence) => (
                          <option key={workExpirence?.id} value={workExpirence?.id}>
                            {workExpirence?.option}
                          </option>
                        ))}
                    </select>
                  ) : (
                    <p>
                      {workExpirences.length > 0 &&
                        workExpirences?.find((wE) => wE?.id == formik.values.work_experience_id)
                          ?.option}
                    </p>
                  )}
                  {/* end::Input */}
                  {formik.touched.work_experience_id && formik.errors.work_experience_id && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.work_experience_id}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className='vacancy_title_section mb-1'>
              <h3 className='mb-0'>{intl.formatMessage({id: 'POSTING_INFORMATION'})}</h3>
            </div>
            <div className='d-flex justify-space-between flex-wrap justify-content-between gap-2 align-items-stretch'>
              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label fw-semibold fs-6'>
                  {intl.formatMessage({id: 'ANNOUNCEMENT.LANGUAGE'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <select
                      {...formik.getFieldProps('language_id')}
                      className={clsx(
                        'form-select form-select-solid mb-3 mb-lg-0',
                        {
                          'is-invalid': formik.touched.language_id && formik.errors.language_id,
                        },
                        {
                          'is-valid': formik.touched.language_id && !formik.errors.language_id,
                        }
                      )}
                      data-kt-select2='true'
                      data-placeholder='Select '
                      data-allow-clear='true'
                      disabled={formik.isSubmitting}
                    >
                      <option value=''>{intl.formatMessage({id: 'SELECT'})}</option>

                      {languages.length > 0 &&
                        languages.map((language) => (
                          <option key={language?.id} value={language?.id}>
                            {language?.name}
                          </option>
                        ))}
                    </select>
                  ) : (
                    <p>
                      {languages.length > 0 &&
                        languages?.find((l) => l?.id == formik.values.language_id)?.name}
                    </p>
                  )}
                  {/* end::Input */}
                  {formik.touched.language_id && formik.errors.language_id && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.language_id}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label fw-semibold fs-6'>
                  {intl.formatMessage({id: 'AD.TITLE'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <input
                      type='text'
                      placeholder={intl.formatMessage({id: 'AD.TITLE'})}
                      {...formik.getFieldProps('title')}
                      className={clsx(
                        'form-control form-control-solid mb-3 mb-lg-0',
                        {
                          'is-invalid': formik.touched.title && formik.errors.title,
                        },
                        {
                          'is-valid': formik.touched.title && !formik.errors.title,
                        }
                      )}
                    />
                  ) : (
                    <p>{formik.values.title}</p>
                  )}
                  {/* end::Input */}
                  {formik.touched.title && formik.errors.title && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.title}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label fw-semibold fs-6'>
                  {intl.formatMessage({id: 'ANNOUCEMENT.TEXT'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <textarea
                      rows={5}
                      placeholder={intl.formatMessage({id: 'ANNOUCEMENT.TEXT'})}
                      {...formik.getFieldProps('description')}
                      className={clsx(
                        'form-control form-control-solid mb-3 mb-lg-0',
                        {
                          'is-invalid': formik.touched.description && formik.errors.description,
                        },
                        {
                          'is-valid': formik.touched.description && !formik.errors.description,
                        }
                      )}
                    ></textarea>
                  ) : (
                    <p>{formik.values.description}</p>
                  )}
                  {/* end::Input */}
                  {formik.touched.description && formik.errors.description && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.description}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label fw-semibold fs-6'>
                  {intl.formatMessage({id: 'QUESTIONS'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <MultiSelect
                      hasSelectAll={false}
                      className='select-dropdown'
                      placeholder={intl.formatMessage({id: 'SELECT'})}
                      value={selectQuess}
                      options={quess}
                      styles={customStyles}
                      onChange={(opt) => {
                        setSelectQuess(opt)
                        formik.setFieldValue(
                          'questions',
                          opt?.map((p) => p?.value)
                        )
                      }}
                    />
                  ) : (
                    <p>{selectQuess && selectQuess?.map((sQ) => sQ?.label).join(',')}</p>
                  )}

                  {formik.touched.questions && formik.errors.questions && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.questions}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className='vacancy_title_section mb-1'>
              <h3 className='mb-0'>{intl.formatMessage({id: 'HIRING_TEM_INFORMATION'})}</h3>
            </div>

            <div className='d-flex justify-space-between flex-wrap justify-content-between gap-2 align-items-stretch'>
              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label fw-semibold fs-6'>
                  {intl.formatMessage({id: 'AUTHORITIES'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <MultiSelect
                      hasSelectAll={false}
                      className='select-dropdown'
                      placeholder={intl.formatMessage({id: 'SELECT'})}
                      value={selectAbilities}
                      options={users}
                      styles={customStyles}
                      isMulti
                      onChange={(opt) => {
                        setSelectAbilities(opt)
                        formik.setFieldValue(
                          'positions',
                          opt?.map((p) => p?.value)
                        )
                      }}
                    />
                  ) : (
                    <p>{selectAbilities && selectAbilities?.map((sA) => sA?.label).join(',')}</p>
                  )}

                  {/* end::Input */}
                  {formik.touched.positions && formik.errors.positions && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.positions}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label fw-semibold fs-6'>
                  {intl.formatMessage({id: 'INTERVIEWERS'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <MultiSelect
                      hasSelectAll={false}
                      className='select-dropdown'
                      placeholder={intl.formatMessage({id: 'SELECT'})}
                      value={selectUsers}
                      options={users}
                      styles={customStyles}
                      isMulti
                      onChange={(opt) => {
                        setSelectUsers(opt)
                        formik.setFieldValue(
                          'employees',
                          opt?.map((p) => p?.value)
                        )
                      }}
                    />
                  ) : (
                    <p>{selectUsers && selectUsers?.map((us) => us?.label).join(',')}</p>
                  )}

                  {/* end::Input */}
                  {formik.touched.employees && formik.errors.employees && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.employees}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className='vacancy_title_section mb-1'>
              <h3 className='mb-0'>{intl.formatMessage({id: 'SALARY_AND_GRADE_INFORMATION'})}</h3>
            </div>

            <div className='d-flex justify-space-between flex-wrap justify-content-between gap-2 align-items-stretch'>
              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label required fw-semibold fs-6'>
                  {intl.formatMessage({id: 'SALARY.MINIMUM'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <input
                      type='number'
                      {...formik.getFieldProps('salary_min')}
                      name='salary_min'
                      className={clsx(
                        'form-control form-control-solid mb-3 mb-lg-0',
                        {
                          'is-invalid': formik.touched.salary_min && formik.errors.salary_min,
                        },
                        {
                          'is-valid': formik.touched.salary_min && !formik.errors.salary_min,
                        }
                      )}
                      autoComplete='off'
                      disabled={formik.isSubmitting}
                    />
                  ) : (
                    <p>{formik.values.salary_min}</p>
                  )}

                  {formik.touched.salary_min && formik.errors.salary_min && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.salary_min}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label required fw-semibold fs-6'>
                  {intl.formatMessage({id: 'SALARY.MAXIMUM'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <input
                      type='number'
                      {...formik.getFieldProps('salary_max')}
                      name='salary_max'
                      className={clsx(
                        'form-control form-control-solid mb-3 mb-lg-0',
                        {
                          'is-invalid': formik.touched.salary_max && formik.errors.salary_max,
                        },
                        {
                          'is-valid': formik.touched.salary_max && !formik.errors.salary_max,
                        }
                      )}
                      autoComplete='off'
                      disabled={formik.isSubmitting}
                    />
                  ) : (
                    <p>{formik.values.salary_max}</p>
                  )}

                  {formik.touched.salary_max && formik.errors.salary_max && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.salary_max}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='d-flex flex-column gap-2 mb-6 col-lg-2 col-12 col-md-2'>
                <label className='col-form-label required fw-semibold fs-6'>
                  {intl.formatMessage({id: 'GRADE'})}
                </label>
                <div className='fv-row fv-plugins-icon-container'>
                  {pathname.includes('view') == false ? (
                    <input
                      type='text'
                      {...formik.getFieldProps('grade')}
                      name='grade'
                      className={clsx(
                        'form-control form-control-solid mb-3 mb-lg-0',
                        {
                          'is-invalid': formik.touched.grade && formik.errors.grade,
                        },
                        {
                          'is-valid': formik.touched.grade && !formik.errors.grade,
                        }
                      )}
                      autoComplete='off'
                      disabled={formik.isSubmitting}
                    />
                  ) : (
                    <p>{formik.values.grade}</p>
                  )}

                  {formik.touched.grade && formik.errors.grade && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.grade}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className='card-footer d-flex justify-content-end py-6 px-9'>
            <Link
              to=''
              type='reset'
              onClick={() => navigate(-1)}
              disabled={formik.isSubmitting}
              className='btn btn-light btn-active-light-primary me-2'
            >
              {intl.formatMessage({id: 'DISCARD'})}
            </Link>
            {pathname.includes('view') == false && (
              <button
                type='submit'
                disabled={formik.isSubmitting || !formik.isValid || !formik.touched}
                className='btn btn-primary'
                id='kt_account_profile_details_submit'
              >
                <span className='indicator-label'>
                  {formik.isSubmitting
                    ? intl.formatMessage({id: 'PLEASE.WAIT'})
                    : intl.formatMessage({id: 'AUTH.GENERAL.SUBMIT_BUTTON'})}
                </span>
              </button>
            )}
          </div>
        </form>
        {formik.isSubmitting && <VacancyistLoading />}
      </div>
    </div>
  )
}

export default CreateVacancyOrUpdatePage
